import {Group} from '../../models/group';
import {BijbError} from '../../models/bijb-error';
import {LoadableState} from './loadable-state';
import {autoserializeAs, inheritSerialization} from 'cerialize';

@inheritSerialization(LoadableState)
export class GroupsState extends LoadableState {
  public static readonly key = 'GroupsState';

  @autoserializeAs(Group, 'groups')
  public groups: Group[] = [];

  @autoserializeAs(BijbError, 'error')
  public error: BijbError = null;

}
